"use strict";
/**
 * Node.js implementation of the HTTP(S) request function.
 *
 * @packageDocumentation
 * @internal
 * @hidden
 */

var _defineProperty = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRequest = exports.isBrowser = void 0;

var url_1 = require("url");

var btoa_1 = require("./btoa");

var joinPath_1 = require("./joinPath");

var omit_1 = require("./omit");

var xhr_1 = require("./xhr");

exports.isBrowser = true;
/**
 * Create a function for performing requests against a given host.
 *
 * @param baseUrl - Base URL of the host, i.e. protocol, port and domain name.
 * @param agentOptions - Options to use for performing requests.
 *
 * @param baseUrl
 * @param agentOptions
 *
 * @internal
 * @hidden
 */

function createRequest(baseUrl, agentOptions) {
  var _url_1$parse = url_1.parse(baseUrl),
      auth = _url_1$parse.auth,
      baseUrlParts = _objectWithoutProperties(_url_1$parse, ["auth"]);

  var options = omit_1.omit(agentOptions, ["maxSockets"]);
  return function request(_ref, cb) {
    var method = _ref.method,
        url = _ref.url,
        headers = _ref.headers,
        body = _ref.body,
        timeout = _ref.timeout,
        expectBinary = _ref.expectBinary;

    var urlParts = _objectSpread(_objectSpread({}, baseUrlParts), {}, {
      pathname: url.pathname ? baseUrlParts.pathname ? joinPath_1.joinPath(baseUrlParts.pathname, url.pathname) : url.pathname : baseUrlParts.pathname,
      search: url.search ? baseUrlParts.search ? "".concat(baseUrlParts.search, "&").concat(url.search.slice(1)) : url.search : baseUrlParts.search
    });

    if (!headers["authorization"]) {
      headers["authorization"] = "Basic ".concat(btoa_1.btoa(auth || "root:"));
    }

    var _callback = function callback(err, res) {
      _callback = function callback() {
        return undefined;
      };

      cb(err, res);
    };

    var req = xhr_1.default(_objectSpread(_objectSpread({
      useXDR: true,
      withCredentials: true
    }, options), {}, {
      responseType: expectBinary ? "blob" : "text",
      url: url_1.format(urlParts),
      body: body,
      method: method,
      headers: headers,
      timeout: timeout
    }), function (err, res) {
      if (!err) {
        var response = res;
        response.request = req;
        if (!response.body) response.body = "";

        if (options.after) {
          options.after(null, response);
        }

        _callback(null, response);
      } else {
        var error = err;
        error.request = req;

        if (options.after) {
          options.after(error);
        }

        _callback(error);
      }
    });

    if (options.before) {
      options.before(req);
    }
  };
}

exports.createRequest = createRequest;